import { IressStack } from '@iress-oss/ids-components';
import { FC, PropsWithChildren } from 'react';
import { EntityDetails } from '../EntityDetails';
import { PageHeaderWithNavigation } from '../PageHeaderWithNavigation/PageHeaderWithNavigation';

export const Screen: FC<
    PropsWithChildren<{
        title: string;
        withSubheading?: boolean;
        withButtons?: boolean;
    }>
> = ({ children, title, withSubheading, withButtons }) => (
    <div data-testid={'screen'}>
        <EntityDetails />
        <PageHeaderWithNavigation title={title} withSubheading={withSubheading} withButtons={withButtons} />
        <IressStack gutter="md">{children}</IressStack>
    </div>
);
